import { QueryStringInput } from '@hello-aria/query-string'
import { isNil } from 'lodash'
import { PaymentReconciliationGateway } from '../../../shared/models/paymentReconciliationModel'
import { type Page, toListQuery } from '@hello-aria/makalu-api-client'
import { makaluApi } from '../../../shared/utils/makaluApiClient'
import { batchFetch } from '../../../shared/utils/requestsUtils'
import { handleHttpError } from '@/shared/utils/queryUtils'

interface ListPaymentReconciliationsParams {
    companyId: string
    query?: QueryStringInput
    signal?: AbortSignal
}

export const listPaymentReconciliations = batchFetch(
    async (params: ListPaymentReconciliationsParams): Promise<Page<PaymentReconciliationGateway>> => {
        try {
            return await makaluApi.listPage('/companies/{companyId}/payment-reconciliations', {
                params: {
                    path: { companyId: params.companyId },
                    query: toListQuery({
                        ...params.query,
                        sorts: params.query?.sorts ?? [
                            {
                                path: 'createdAt',
                                direction: 'desc'
                            }
                        ]
                    })
                },
                signal: params.signal
            })
        } catch (error) {
            return handleHttpError('listPaymentReconciliations', error)
        }
    }
)

export const getPaymentReconciliation = async (
    companyId: string,
    paymentReconciliationId: string | null | undefined
): Promise<PaymentReconciliationGateway | undefined> => {
    if (isNil(paymentReconciliationId)) return

    try {
        return await makaluApi.GET('/companies/{companyId}/payment-reconciliations/{paymentReconciliationId}', {
            params: { path: { companyId, paymentReconciliationId } }
        })
    } catch (error) {
        return handleHttpError('getPaymentReconciliation', error)
    }
}
